import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { TextareaState } from 'src/components/FormComponents/Textarea/Textarea.state';
import { TextareaStatus } from 'src/components/FormComponents/Textarea/TextareaStatus';
import { TextareaElement, Wrapper } from 'src/domains/layouts/shared/formComponents/textarea/Textarea.style';
// @ts-expect-error
import CKEditor from 'react-ckeditor-component';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import { InputError, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { hideErrorMessage } from './Textarea';

interface PropsType {
    label?: string;
    placeholder?: string;
    formState: FormInputState<string>;
    model: FormModel<string>;
    status: TextareaStatus;
    maxLength?: number;
    ckeditor?: boolean;
    dataTest?: string;
}

/**
 * @deprecated please use Textarea from src/domains/layouts/shared/formComponents/textarea/Textarea.tsx
 */

export const OldTextarea = observer('OldTextarea', (props: PropsType) => {
    const { label, placeholder, maxLength, formState, status, model, dataTest, ckeditor } = props;
    const [textareaState] = React.useState(() => new TextareaState(formState, model));
    const { type: statusType, message: statusMessage } = status;

    const renderErrorMessage = (): JSX.Element | null => {
        if (statusType === 'error' && statusMessage !== null) {
            return <InputError>{statusMessage}</InputError>;
        }
        return null;
    };

    const handleChangeCKEditor = (evt: CKEditor): void => {
        const newContent = evt.editor.getData();
        formState.setValue(newContent);
    };

    const renderEditor = (): JSX.Element => {
        if (ckeditor === true) {
            return (
                <CKEditor
                    key='editor'
                    activeClass='p10'
                    content={textareaState.value}
                    events={{
                        blur: textareaState.handleBlur,
                        change: handleChangeCKEditor,
                        instanceReady: hideErrorMessage,
                    }}
                    data-test={dataTest}
                />
            );
        }

        return (
            <TextareaElement
                key='textarea'
                placeholder={placeholder}
                value={textareaState.value}
                maxLength={maxLength}
                onBlur={textareaState.handleBlur}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>): void => formState.setValue(e.target.value)}
                data-test={dataTest}
            />
        );
    };

    return (
        <Wrapper>
            {label === undefined ? null : <InputLabel>{label}</InputLabel>}
            {renderEditor()}
            {renderErrorMessage()}
        </Wrapper>
    );
});
